import { InfoOutlined } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import React from 'react';

const StyledSimpleRowCard = styled('div')({
  width: '400px',
  maxWidth: '100%',
  border: '1px solid var(--green)',
  borderRadius: '20px',
  boxShadow: '0px 4px 15px rgba(62, 164, 72, 0.1)',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '10px 20px',
  fontSize: '16px',
  fontWeight: 500,
  '&:hover': {
    cursor: 'pointer',
    transform: 'scale(1.02)',
    boxShadow: '0px 8px 15px rgba(62, 164, 72, 0.1)',
  },
  '&:active': {
    background: 'var(--light-gray)',
  },
});

const StyledEditIcon = styled(EditIcon)({
  width: '1.5rem',
  height: '2rem',
  color: 'var(--blue)',
  marginLeft: 'auto'

});

const StyledInfoIcon = styled(InfoOutlined)({
  width: '1.5rem',
  height: '2rem',
  color: 'var(--blue)',
  marginLeft: 'auto'
});

function SimpleRowCard({ label, icon, onClick, style, disabled = false }) {
  return (
    <StyledSimpleRowCard onClick={onClick} sx={style}>
      <div style={{ marginRight: '12px', display: 'flex', justifyContent: 'center' }}>
        {icon}
      </div>
      <div style={{ width: '65%'}}>
        <span style={{ wordBreak: 'break-word' }}>{label}</span>
      </div>
      {!disabled ?
        <StyledEditIcon />
        :
        <StyledInfoIcon />
      }
    </StyledSimpleRowCard>
  );
};

export default SimpleRowCard;
